module.exports = __webpack_public_path__ + "static/media/sm.2dc37fb9.svg";